export const imageDefaults = {
    avatar: "https://praysely.blob.core.windows.net/defaults/avatar.jpg",
    church: "https://praysely.blob.core.windows.net/defaults/avatar.jpg"
}